"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _Raven = _interopRequireDefault(require("Raven"));

var _enviro = _interopRequireDefault(require("enviro"));

var _loggers = require("customer-data-tracking/loggers");

function _default(chunkName) {
  return function asyncComponentErrorHandler(error) {
    var errorMessage = "Failed to load chunk " + chunkName;

    if (!_enviro.default.deployed()) {
      // eslint-disable-next-line no-console
      console.warn(errorMessage); // eslint-disable-next-line no-console

      console.error(error);
      return null;
    }

    _Raven.default.captureMessage(errorMessage, {
      extra: {
        chunkName: chunkName,
        originalError: error
      }
    });

    _loggers.CrmLogger.log('debugChunkLoadIssues', {
      chunk: chunkName,
      error: error && error.message || "unknown error loading chunk " + chunkName
    });

    return null;
  };
}

module.exports = exports.default;